
<template>
  <h4 class="com-img-desc">{{ dataInfo.value }}</h4>
</template>

<script>
import { CptMixin } from '../../../mixins/CptMixin'
export default {
  mixins: [CptMixin],
}
</script>

<style lang="less">
.com-img-desc {
  height: auto;
  padding: 12px 0 0;
  margin: -10px 0 20px;
  text-align: center;
  font-size: 13px;
  color: #8c96a0;
  font-weight: 400;
}
</style>